import {
  LOGOUT,
  SET_ACTIVE_FILTERS,
  SET_ALL_PAGES,
  SET_CURRECT_PAGE,
  SET_FILTERS_DATA,
  SET_PAGGING_QUERY,
  SET_QUERY,
} from "../constans/reducerActions";
import { defaultQuery } from "../reducer/init";
import {
  deleteTableRecord,
  fetchFilteredTableData,
  fetchTableData,
  fetchTableOptions,
  fetchTablePageData,
  fetchUserProfile,
} from "./panelApi";

const INFO_TYPE_SUCCESS = "Succes";
const INFO_TYPE_FAIL = "Fail";

const INFO_MESSAGE_FILTER_FAIL = "BLAD!";
const INFO_MESSAGE_DELETE_SUCCESS = "Udalo sie usunac!";
const INFO_MESSAGE_DELETE_FAIL = "Nie udalo sie usunac!";

const FAILED_DELETE_CODES = [400, 401];

function getDocsRows(docs) {
  return Array.isArray(docs?.docs) ? docs.docs : [];
}

function updatePagination(dispatch, docs) {
  dispatch({ type: SET_CURRECT_PAGE, item: docs?.page || 1 });
  dispatch({ type: SET_ALL_PAGES, item: docs?.totalPages || 1 });
}

function createDeleteConfirmMessage(item = {}) {
  return `Czy na pewno chcesz usunac ten rekord?
      Kampania: ${item.Kampania || "-"}
      Klient: ${item.Klient || "-"}
      Kategoria: ${item.Kategoria || "-"}
      Format: ${item.Format || "-"}
    `;
}

export function createPanelController({
  choosenTable,
  dispatch,
  setArr,
  setClearForm,
  setName,
  setImg,
  setInfoType,
  setInfo,
}) {
  const loadData = async () => {
    setArr(null);

    try {
      const docs = await fetchTableData(choosenTable);
      const data = getDocsRows(docs);

      setClearForm(true);
      setArr(data);

      dispatch({ type: SET_ACTIVE_FILTERS, item: [] });
      dispatch({ type: SET_PAGGING_QUERY, item: defaultQuery });
      dispatch({ type: SET_QUERY, item: defaultQuery });
      updatePagination(dispatch, docs);
    } catch (err) {
      console.error(err);
    }
  };

  const loadFiltersData = async () => {
    try {
      setArr(null);
      const docs = await fetchTableOptions(choosenTable);
      dispatch({ type: SET_FILTERS_DATA, item: docs });
    } catch (err) {
      console.error(err);
      dispatch({ type: LOGOUT });
    }
  };

  const applyFilters = async (queryString, nextQuery) => {
    setArr(null);

    try {
      const docs = await fetchFilteredTableData(choosenTable, queryString);
      const data = getDocsRows(docs);

      setArr(data);
      dispatch({ type: SET_PAGGING_QUERY, item: nextQuery });
      dispatch({ type: SET_ACTIVE_FILTERS, item: { ...nextQuery } });
      updatePagination(dispatch, docs);
    } catch (err) {
      console.error(err);
      setInfoType(INFO_TYPE_FAIL);
      setInfo(INFO_MESSAGE_FILTER_FAIL);
    }
  };

  const changePage = async (queryString, pageNumber) => {
    setArr(null);

    try {
      const docs = await fetchTablePageData(choosenTable, pageNumber, queryString);
      const data = getDocsRows(docs);

      setClearForm(true);
      setArr(data);
      updatePagination(dispatch, docs);
    } catch (err) {
      console.error(err);
      setInfoType(INFO_TYPE_FAIL);
      setInfo(INFO_MESSAGE_FILTER_FAIL);
    }
  };

  const removeElement = async (id, item) => {
    const isConfirmed = window.confirm(createDeleteConfirmMessage(item));
    if (!isConfirmed) return;

    try {
      const response = await deleteTableRecord(choosenTable, id);

      if (response.status === 200) {
        setInfoType(INFO_TYPE_SUCCESS);
        setInfo(INFO_MESSAGE_DELETE_SUCCESS);
        await loadData();
        return;
      }

      if (FAILED_DELETE_CODES.includes(response.status)) {
        setInfoType(INFO_TYPE_FAIL);
        setInfo(INFO_MESSAGE_DELETE_FAIL);
      }
    } catch (err) {
      console.error(err);
      setInfoType(INFO_TYPE_FAIL);
      setInfo(INFO_MESSAGE_DELETE_FAIL);
    }
  };

  const loadProfile = async () => {
    try {
      const data = await fetchUserProfile();
      setName(data?.name || "User");
      setImg(data?.img || "");
    } catch (err) {
      console.error(err);
    }
  };

  return {
    loadData,
    loadFiltersData,
    applyFilters,
    changePage,
    removeElement,
    loadProfile,
  };
}
